import { useEffect, useState } from 'react';

import ApplicationsGrid from 'components/ApplicationsGrid';
import Page from 'components/Page';

import useApplications from 'hooks/useApplications';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ApplicationsPage: FunctionComponent<Props> = ({ className = '', testId = TEST_ID }) => {
    const { applications = [], fetch } = useApplications();
    const [hasMore, setHasMore] = useState(false);

    useEffect(() => {
        (async () => {
            const { done } = await fetch().next();

            setHasMore(!done);
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleNext = async () => await fetch().next();

    return (
        <Page className={`${className} ${styles.applicationsPage}`} testId={testId}>
            <ApplicationsGrid onNext={hasMore ? handleNext : undefined} rows={applications} />
        </Page>
    );
};

export default ApplicationsPage;
